export default __webpack_public_path__ + "static/media/yuzu.f4044340.svg";